import type { FaireProductEntity } from "../../entity_types/product";

export const p_u747wku2ha: FaireProductEntity = {
  token: "p_u747wku2ha",
  type: "product",
  name: 'Raw "Bluebird" Azurite Clusters from Morenci, Arizona',
  brandToken: "b_fak8czuqg9",
  brandName: "Mandala Gems",
  imageUrl:
    "https://cdn.faire.com/fastly/84f4491b5b21bdea9da6acff2f587eb192d78809d898e8d1e24f9bfe3305ea24.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f41b450c97ae8abfbc83486b822fea8120399273d91beba13dc7c4dd91f93202.jpeg",
    "https://cdn.faire.com/fastly/3258f95397e97899a493a93d88fbf13c7e8b1303695d700f00727ab6f351e28a.jpeg",
    "https://cdn.faire.com/fastly/6bebe3f712640059a0b53f69349f69deaaa27c0ded6a49e4125a2607559717aa.jpeg",
  ],
  priceDollars: 17.5,
  description:
    "“Bluebird” Raw Azurite – Arizona\n\nIntense color. Classic locality.\n\nThese raw “Bluebird” Azurite specimens come from Arizona and are known for their deep, electric blue color that collectors immediately recognize. The rich saturation and velvety surface texture give these pieces a striking presence, even in smaller sizes.\n\nBluebird azurite is highly sought after because of its vibrant, almost neon-blue tone and strong locality reputation. Arizona azurite has long been prized in both the mineral collector and metaphysical markets for its bold color and classic Southwestern origin.\n\nThese specimens perform especially well for:\n• Collector mineral sections\n• Southwestern and U.S. locality displays\n• Blue crystal collections\n• Intuition and third eye themed displays\n• High-impact tray or case arrangements\n\nMerchandising suggestions:\n• Display under bright lighting to enhance color depth\n• Group with malachite or other copper minerals for visual contrast\n• Add locality labeling to increase perceived value\n• Position in eye-level mineral cases for collector appeal\n\nEach piece will vary naturally in shape, surface texture, and matrix presence due to genuine mineral formation.\n\nA vivid, collector-favorite azurite that adds serious color and locality credibility to any mineral display. 🔵✨\n\n",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:13.296Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
